<template>
  <div>
    <vs-row class="al-center">
      <h2 style="font-weight: 600" class="ml-2">{{ text }}</h2>
      <vs-spacer />
      <vs-select class="selectExample" width="120px" v-model="select1" @change="linechart">
        <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in options_graph" />
      </vs-select>
      <btnExportXLSX :dataList="exportdata" :headerName="'Power Consumption'" />
    </vs-row><br />
    <div style="position: relative; width: 100%">
      <barchart v-if="datacollection_power != null" :height="heightgrapg" :chartData="datacollection_power"
        :options="option_power" :dataLabel="true"></barchart>
    </div>
  </div>
</template>

<script>
import barchart from "./barchart";
import btnExportXLSX from "./../Button/btnExportXLSX.vue";
import ChartDataLabels from "chartjs-plugin-datalabels";
export default {
  components: { barchart, btnExportXLSX },
  props: ["text", "colorgraph", "heightgrapg", "datasets3", "fontcolor"],
  data() {
    return {
      select1: "month",
      options_graph: [
        // { text: "Day", value: "day" },
        { text: "Month", value: "month" },
        { text: "Year", value: "Year" },
      ],
      datacollection_power: null,
      option_power: null,
      exportdata: [],
    };
  },
  methods: {
    linechart() {
      console.log(this.select1);
      let datasets = this.datasets3[this.select1];
      let data = [];
      let labels = [];
      // datasets.reverse()
      console.log('LineCharts', this.select1, datasets, this.datasets3)

      for (let i = datasets.length - 1; i >= 0; i--) {
        const el = datasets[i];

        if (this.select1 == "day") {
          labels.push(el.time.split(" ")[1]);
          data.push(el.volume);
        } else if (this.select1 == "month") {
          labels.push(el.time.split(" ")[0]);
          data.push(el.volume);
        } else {
          if (el.time != "March") {
            labels.push(el.time);
            data.push(el.volume);
          }
          // labels.push(el.time);
          //  data.push(el.volume);
        }
      }

      console.log('TEST.labels', labels)

      this.exportdata = datasets;
      this.datacollection_power = {
        labels: labels,
        datasets: [
          {
            data: data,
            borderWidth: 1.5,
            borderColor: "#fff",
            backgroundColor: "#62B382",
          },
        ],
      };
      this.option_power = {
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          display: false,
          position: "bottom",
        },
        // plugins: [ChartDataLabels],
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              var tooltipValue =
                data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
              return parseInt(tooltipValue).toLocaleString();
            },
          },
        },
        plugins: {
          datalabels: {
            // color: "white",
            textAlign: "center",
            formatter: function (value, index, values) {
              return value.toLocaleString(); // this is all we need
            },
            font: {
              weight: "bold",
              size: 16,
            },
          },
        },
        scales: {
          yAxes: [
            {
              id: "A",
              ticks: {
                beginAtZero: true,
                steps: 5,
                stepValue: 5,
                userCallback: function (value, index, values) {
                  return value.toLocaleString(); // this is all we need
                },
              },
              position: "left",
              scaleLabel: {
                display: true,
                labelString: "kWh History",
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      };
      console.log("this.fontcolor", this.fontcolor)
      if (this.fontcolor) {
        console.log("this.option_power", this.option_power.plugins.datalabels)
        this.option_power.plugins.datalabels = {...this.option_power.plugins.datalabels, color: this.fontcolor}
      }
    },
  },
  mounted() {
    console.log(this.datasets3);
    this.linechart();
  },
  watch: {
    datasets3: {
      // watch it
      handler(newValue, oldValue) {
        console.log("redraw bar chart datasets3");
        // console.log(newValue, oldValue);
        this.linechart();
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
/* .aText {
  font-size: 0.1rem;
} */
.al-center {
  align-items: center;
}
</style>